export type Utms = {
  utm_source?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  utm_term?: string | null;
  utm_content?: string | null;
  utm_id?: string | null;
  utm_source_platform?: string | null;
  utm_creative_format?: string | null;
  utm_marketing_tactic?: string | null;
  gclid?: string | null;
  gbraid?: string | null;
  wbraid?: string | null;
  fbclid?: string | null;
  msclkid?: string | null;
  ttclid?: string | null;
  li_fat_id?: string | null;
};

export type UtmAttribution = {
  first?: Utms;
  last?: Utms;
  firstCapturedAt?: string;
  lastCapturedAt?: string;
};

const STORAGE_KEY = 'tracked_utms';

const UTM_KEYS: (keyof Utms)[] = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'utm_source_platform',
  'utm_creative_format',
  'utm_marketing_tactic',
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'msclkid',
  'ttclid',
  'li_fat_id',
];

const temUtms = (utms?: Utms | null) => Boolean(utms && UTM_KEYS.some((chave) => Boolean(utms[chave])));

/**
 * Mesma chave, mesmo formato e mesma regra de first/last do UtmService do site.
 * Os dois NÃO compartilham storage — são domínios diferentes — mas o backend
 * recebe o mesmo objeto dos dois, então o contrato é um só.
 */
export class UtmService {
  /**
   * O chatbot usa HashRouter, então a query pode vir antes do # (o normal, de
   * um link de campanha) ou depois dele, se o link já apontar para uma tela
   * específica. Vale ler os dois lugares.
   */
  private static utmsDaUrl(): Utms {
    const busca = new URLSearchParams(window.location.search);

    const hash = window.location.hash;
    const inicioDaQueryNoHash = hash.indexOf('?');
    const buscaNoHash = new URLSearchParams(
      inicioDaQueryNoHash >= 0 ? hash.slice(inicioDaQueryNoHash + 1) : ''
    );

    const utms: Utms = {};
    UTM_KEYS.forEach((chave) => {
      const valor = busca.get(chave) || buscaNoHash.get(chave);
      if (valor) {
        utms[chave] = valor;
      }
    });

    return utms;
  }

  /**
   * Guarda o primeiro toque uma vez só e atualiza o último a cada entrada.
   * Chamada no start da aplicação: sem UTM na URL, não mexe no que já existe.
   */
  static capturarDaUrl(): void {
    if (typeof window === 'undefined') {
      return;
    }

    const daUrl = this.utmsDaUrl();
    if (!temUtms(daUrl)) {
      return;
    }

    const guardado = this.getStoredUtmAttribution();
    const agora = new Date().toISOString();

    this.salvar({
      first: temUtms(guardado.first) ? guardado.first : daUrl,
      last: daUrl,
      firstCapturedAt: guardado.firstCapturedAt || agora,
      lastCapturedAt: agora,
    });
  }

  static getStoredUtmAttribution(): UtmAttribution {
    if (typeof window === 'undefined') {
      return {};
    }

    try {
      const cru = localStorage.getItem(STORAGE_KEY);
      if (!cru) {
        return {};
      }

      return JSON.parse(cru) as UtmAttribution;
    } catch {
      return {};
    }
  }

  private static salvar(attribution: UtmAttribution): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    } catch {
      // Navegador com storage bloqueado: o cadastro é mais importante que a origem.
    }
  }
}
